{
  "$generated": "scripts/import-price-sheets.mjs - do not hand-edit tables; edit the source sheet and re-run.",
  "id": "cd-dvd",
  "label": "CD & DVD Duplication",
  "type": "tiered-table",
  "quantityLabel": "Quantity",
  "unitLabel": "disc",
  "capAtNextBreak": true,
  "aboveMax": "quote",
  "options": [
    {
      "id": "media",
      "label": "Disc type",
      "choices": [
        {
          "id": "cd",
          "label": "CD"
        },
        {
          "id": "dvd",
          "label": "DVD"
        }
      ]
    },
    {
      "id": "package",
      "label": "Packaging",
      "choices": [
        {
          "id": "4-panel-digi-pak",
          "label": "4-panel Digi-Pak"
        },
        {
          "id": "6-panel-digi-pak",
          "label": "6-panel Digi-Pak"
        },
        {
          "id": "magic-jacket-sleeve",
          "label": "Magic Jacket™/Sleeve"
        },
        {
          "id": "4-panel-wallet",
          "label": "4-panel Wallet"
        },
        {
          "id": "6-panel-wallet",
          "label": "6-panel Wallet"
        },
        {
          "id": "jewel-box-2-panel-insert",
          "label": "Jewel Box - 2-panel insert"
        },
        {
          "id": "jewel-box-4-panel-insert",
          "label": "Jewel Box - 4-panel insert"
        },
        {
          "id": "jewel-box-6-panel-insert",
          "label": "Jewel Box - 6-panel insert"
        },
        {
          "id": "jewel-box-8-page-booklet",
          "label": "Jewel Box - 8 page booklet"
        },
        {
          "id": "jewel-box-12-page-booklet",
          "label": "Jewel Box - 12 page booklet"
        },
        {
          "id": "jewel-box-16-page-booklet",
          "label": "Jewel Box - 16 page booklet"
        },
        {
          "id": "jewel-box-20-page-booklet",
          "label": "Jewel Box - 20 page booklet"
        },
        {
          "id": "jewel-box-24-page-booklet",
          "label": "Jewel Box - 24 page booklet"
        },
        {
          "id": "bulk",
          "label": "Bulk discs (no packaging)"
        },
        {
          "id": "amaray-case",
          "label": "Amaray Case"
        }
      ]
    }
  ],
  "tables": [
    {
      "when": {
        "media": "cd",
        "package": "4-panel-digi-pak"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.42
        },
        {
          "qty": 150,
          "unit": 3.46
        },
        {
          "qty": 300,
          "unit": 3.15
        },
        {
          "qty": 500,
          "unit": 2.93
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.1: \"CD’s in 4-panel Digi-Pak\""
    },
    {
      "when": {
        "media": "cd",
        "package": "6-panel-digi-pak"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.66
        },
        {
          "qty": 150,
          "unit": 3.68
        },
        {
          "qty": 300,
          "unit": 3.46
        },
        {
          "qty": 500,
          "unit": 3.25
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.1: \"CD’s in 6-panel Digi-Pak\""
    },
    {
      "when": {
        "media": "cd",
        "package": "magic-jacket-sleeve"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 3.58
        },
        {
          "qty": 150,
          "unit": 2.49
        },
        {
          "qty": 300,
          "unit": 2.28
        },
        {
          "qty": 500,
          "unit": 2.05
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.1: \"CD’s in Magic Jacket™/Sleeve\""
    },
    {
      "when": {
        "media": "cd",
        "package": "4-panel-wallet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.23
        },
        {
          "qty": 150,
          "unit": 3.35
        },
        {
          "qty": 300,
          "unit": 3.12
        },
        {
          "qty": 500,
          "unit": 2.82
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.2: \"CD’s in 4-panel Wallet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "6-panel-wallet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.44
        },
        {
          "qty": 150,
          "unit": 3.46
        },
        {
          "qty": 300,
          "unit": 3.15
        },
        {
          "qty": 500,
          "unit": 2.93
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.2: \"CD’s in 6-panel Wallet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-2-panel-insert"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.11
        },
        {
          "qty": 150,
          "unit": 3.25
        },
        {
          "qty": 300,
          "unit": 2.93
        },
        {
          "qty": 500,
          "unit": 2.49
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.2: \"CD’s in Jewel Box - 2-panel insert\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-4-panel-insert"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.87
        },
        {
          "qty": 150,
          "unit": 3.55
        },
        {
          "qty": 300,
          "unit": 3.25
        },
        {
          "qty": 500,
          "unit": 2.71
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.3: \"CD’s in Jewel Box - 4-panel insert\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-6-panel-insert"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 5.41
        },
        {
          "qty": 150,
          "unit": 4.34
        },
        {
          "qty": 300,
          "unit": 3.8
        },
        {
          "qty": 500,
          "unit": 3.25
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.3: \"CD’s in Jewel Box - 6-panel insert\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-8-page-booklet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 5.74
        },
        {
          "qty": 150,
          "unit": 4.33
        },
        {
          "qty": 300,
          "unit": 3.89
        },
        {
          "qty": 500,
          "unit": 3.36
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.3: \"CD’s in Jewel Box - 8 page booklet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-12-page-booklet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 6.06
        },
        {
          "qty": 150,
          "unit": 4.44
        },
        {
          "qty": 300,
          "unit": 4.11
        },
        {
          "qty": 500,
          "unit": 3.57
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.3: \"CD’s in Jewel Box - 12 page booklet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-16-page-booklet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 6.6
        },
        {
          "qty": 150,
          "unit": 4.97
        },
        {
          "qty": 300,
          "unit": 4.32
        },
        {
          "qty": 500,
          "unit": 3.79
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.4: \"CD’s in Jewel Box - 16 page booklet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-20-page-booklet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 7.14
        },
        {
          "qty": 150,
          "unit": 5.52
        },
        {
          "qty": 300,
          "unit": 4.76
        },
        {
          "qty": 500,
          "unit": 4.22
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.4: \"CD’s in Jewel Box - 20 page booklet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "jewel-box-24-page-booklet"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 7.68
        },
        {
          "qty": 150,
          "unit": 6.06
        },
        {
          "qty": 300,
          "unit": 5.19
        },
        {
          "qty": 500,
          "unit": 4.65
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.4: \"CD’s in Jewel Box - 24 page booklet\""
    },
    {
      "when": {
        "media": "cd",
        "package": "bulk"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.05
        },
        {
          "qty": 150,
          "unit": 1.42
        },
        {
          "qty": 300,
          "unit": 1.2
        },
        {
          "qty": 500,
          "unit": 1.09
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.4: \"Bulk CD’s - includes duplication\""
    },
    {
      "when": {
        "media": "dvd",
        "package": "bulk"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.43
        },
        {
          "qty": 150,
          "unit": 1.76
        },
        {
          "qty": 300,
          "unit": 1.54
        },
        {
          "qty": 500,
          "unit": 1.44
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.5: \"Bulk DVD’s - includes duplication\""
    },
    {
      "when": {
        "media": "dvd",
        "package": "amaray-case"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 4.72
        },
        {
          "qty": 150,
          "unit": 3.75
        },
        {
          "qty": 300,
          "unit": 3.51
        },
        {
          "qty": 500,
          "unit": 3.12
        }
      ],
      "source": "Updated CD & DVD Price List.pdf p.5: \"DVD’s in Amaray Case\""
    }
  ],
  "addons": [
    {
      "id": "no-duplication",
      "label": "No duplication (blank discs)",
      "kind": "per-unit",
      "amount": -0.1,
      "when": {
        "package": [
          "bulk"
        ]
      }
    },
    {
      "id": "c-shell",
      "label": "C-shell",
      "kind": "per-unit",
      "amount": 0.82,
      "when": {
        "package": [
          "bulk"
        ]
      }
    },
    {
      "id": "window-envelope",
      "label": "Window envelope",
      "kind": "per-unit",
      "amount": 0.35,
      "when": {
        "package": [
          "bulk"
        ]
      }
    },
    {
      "id": "slimline-jewel",
      "label": "Slimline jewel box",
      "kind": "per-unit",
      "amount": 0.69,
      "when": {
        "package": [
          "bulk"
        ]
      }
    },
    {
      "id": "standard-jewel",
      "label": "Standard jewel box",
      "kind": "per-unit",
      "amount": 0.98,
      "when": {
        "package": [
          "bulk"
        ]
      }
    },
    {
      "id": "go-retro",
      "label": "Go Retro! vinyl-record look",
      "kind": "per-unit",
      "amount": 0.33,
      "when": {
        "media": [
          "cd"
        ]
      }
    },
    {
      "id": "design-disc",
      "label": "Design Studio: disc imprint",
      "kind": "flat",
      "amount": 44
    },
    {
      "id": "design-sleeve",
      "label": "Design Studio: CD sleeve / Magic Jacket",
      "kind": "flat",
      "amount": 275,
      "when": {
        "package": [
          "magic-jacket-sleeve"
        ]
      }
    },
    {
      "id": "design-digi-4",
      "label": "Design Studio: 4-panel Digi-Pak",
      "kind": "flat",
      "amount": 385,
      "when": {
        "package": [
          "4-panel-digi-pak"
        ]
      }
    },
    {
      "id": "design-digi-6",
      "label": "Design Studio: 6-panel Digi-Pak",
      "kind": "flat",
      "amount": 440,
      "when": {
        "package": [
          "6-panel-digi-pak"
        ]
      }
    },
    {
      "id": "design-booklet-8",
      "label": "Design Studio: 8-page booklet",
      "kind": "flat",
      "amount": 495,
      "when": {
        "package": [
          "jewel-box-8-page-booklet"
        ]
      }
    },
    {
      "id": "design-booklet-12",
      "label": "Design Studio: 12-page booklet",
      "kind": "flat",
      "amount": 550,
      "when": {
        "package": [
          "jewel-box-12-page-booklet"
        ]
      }
    },
    {
      "id": "design-booklet-16",
      "label": "Design Studio: 16-page booklet",
      "kind": "flat",
      "amount": 605,
      "when": {
        "package": [
          "jewel-box-16-page-booklet"
        ]
      }
    },
    {
      "id": "design-booklet-20",
      "label": "Design Studio: 20-page booklet",
      "kind": "flat",
      "amount": 660,
      "when": {
        "package": [
          "jewel-box-20-page-booklet"
        ]
      }
    },
    {
      "id": "design-booklet-24",
      "label": "Design Studio: 24-page booklet",
      "kind": "flat",
      "amount": 715,
      "when": {
        "package": [
          "jewel-box-24-page-booklet"
        ]
      }
    },
    {
      "id": "design-amaray",
      "label": "Design Studio: Amaray insert",
      "kind": "flat",
      "amount": 330,
      "when": {
        "package": [
          "amaray-case"
        ]
      }
    },
    {
      "id": "design-slimline",
      "label": "Design Studio: slimline jewel box",
      "kind": "flat",
      "amount": 220,
      "when": {
        "package": [
          "bulk"
        ]
      }
    }
  ]
}
